import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PdfPreviewDialogComponent} from './pdf-preview-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {LoadingModule} from '@ee/common/loading';
import {MatIconModule} from '@angular/material/icon';
import {TippyDirective} from '@ngneat/helipopper';


@NgModule({
  imports: [CommonModule, MatDialogModule, MatButtonModule, NgxExtendedPdfViewerModule, LoadingModule, MatIconModule, TippyDirective],
  declarations: [PdfPreviewDialogComponent],
  exports: [PdfPreviewDialogComponent]
})
export class PdfPreviewDialogModule {}
